import React, { useEffect, useRef } from 'react';
import Lenis from '@studio-freight/lenis';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Discretion from '../components/Discretion';
import InternationalReach from '../components/InternationalReach';
import About from '../components/About';
import ConsultationForm from '../components/ConsultationForm';
import Footer from '../components/Footer';
import Header from '../components/Header';

const LandingPage = () => {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;
    // Expose globally so any component can trigger cooperative smooth scroll
    window.__lenis = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Services />
      <Discretion />
      <InternationalReach />
      <About />
      <ConsultationForm />
      <Footer />
    </div>
  );
};

export default LandingPage;
